import React from 'react';
import useProjectBreadcrumb from 'src/shared/hooks/useProjectBreadcrumb';
import Loader from 'src/shared/components/loader/Loader';
import StandardAppLayout from 'src/shared/components/layout/standard-app-layout/StandardAppLayout';
import { AppName } from 'src/global/globalConfig';
import useProjectFilters from 'src/shared/hooks/useProjectFilters';
import useFeature from 'src/shared/hooks/useFeature';
import { Resources } from 'src/shared/types';
import DemoProjectBanner from 'src/shared/components/demo-project-banner/DemoProjectBanner';
import Metrics from './components/metrics/Metrics';
import FreemiumDashboard from './components/freemium-dashboard/FreemiumDashboard';
import DashboardFilters from './components/dashboard-filters/DashboardFilters';
import DashboardDataSources from './components/dashboard-data-sources/DashboardDataSources';

const DASHBOARD_TITLE = 'Nature Performance Dashboard';

const Dashboard = () => {
    const { samplingEventFilterData } = useProjectFilters();

    const { hasResource } = useFeature();
    const isDashboardAvailable = hasResource({
        resource: Resources.DASHBOARD,
    });

    const currentProjectBreadcrumbDetails = useProjectBreadcrumb(DASHBOARD_TITLE);

    if (!isDashboardAvailable) {
        return <FreemiumDashboard />;
    }

    if (!samplingEventFilterData) {
        return (
            <>
                <Loader />
            </>
        );
    }

    return (
        <StandardAppLayout
            mainContent={
                <div>
                    <DashboardDataSources />
                    <DashboardFilters />
                    <Metrics />
                </div>
            }
            breadcrumbs={currentProjectBreadcrumbDetails}
            title={DASHBOARD_TITLE}
            subTitle='Trends and indicators'
            topBanner={<DemoProjectBanner pageName={AppName.DASHBOARD} />}
        />
    );
};

export default Dashboard;
